







import { Component, Mixins } from "vue-property-decorator";
import { default as MediaSelectableContentMixin } from "./mixins/MediaSelectableContentMixin.vue";
import { FatalIndicator } from "./common";
import { IExecutable } from "./IExecutable";
import { instanceOfIFixedTextIndicatable } from "../../../../../../domain/format";

@Component({
  components: {
    FatalIndicator,
  }
})
export default class WizardContentClaioSchemaSelector extends Mixins(MediaSelectableContentMixin) implements IExecutable {
  get text(): string {
    return instanceOfIFixedTextIndicatable(this.content)
      ? this.content.fixedText
      : "シェーマ";
  }

  async execute() {
    // TODO: シェーマから張り付ける機能を実装する
    this.$notImplemented("シェーマは未実装です。");
  }
}
